export default __webpack_public_path__ + "static/media/loading.62b3383a.svg";